module.exports = __webpack_public_path__ + "img/bubble-angry.d6e70c7c.svg";